export default __webpack_public_path__ + "img/ba487222f1966b18f89efcc62f0991f4.svg";